import { Component } from '@angular/core';
import { environment } from '@env/fe';
import { ActivatedRoute, UrlSegment } from '@angular/router';

@Component({
  selector: 'twaice-fe-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  standalone: false,
})
export class LoggedOutComponent {
  release: string;
  displayBackButton: boolean;

  constructor(public route: ActivatedRoute) {
    this.release = environment.release;
    this.route.url.subscribe((url: UrlSegment[]) => {
      this.displayBackButton = !!url.length;
    });
  }
}
